import * as types from '../../actions/actionsTypes/recuperoDatiCastellettoActionType';

export const InizilizedStateDatiCastelletto = {
    datiCastelletto: null,
    error: null,
    loading: true
};

export const datiCastellettoRedcuer = (state = InizilizedStateDatiCastelletto, action) => {

    switch (action.type){
        case types.SET_LOADING : {
            return {
                ...state,
                loading: action.loading
            }
        }

        case types.INIT_CASTELLETTO : {
            return {
                datiCastelletto: null,
                error: null,
                loading: true
            }
        }

        case types.GET_DATI_CASTELLETTO_PERIODO_SUCCESS : {
            return {
                ...state,
                datiCastelletto: action.datiCastelletto,
                loading: action.loading
            }
        }

        case types.GET_DATI_CASTELLETTO_PERIODO_FAIL : {
            return {
                ...state,
                error: action.error,
                loading: action.loading
            }
        }

        case types.GET_DATI_CASTELLETTO_PERIODO_TOTALE_SUCCESS : {
            return {
                ...state,
                datiCastelletto: action.datiCastellettoPeriodoTotale,
                loading: false
            }
        }

        case types.GET_DATI_CASTELLETTO_PERIODO_TOTALE_FAIL : {
            return {
                ...state,
                error: action.error,
                loading: false
            }
        }

        default:{
            return state
        }
    }
};




